import { render, staticRenderFns } from "./ReleaseManager.vue?vue&type=template&id=41ced0ac&scoped=true&"
import script from "./ReleaseManager.vue?vue&type=script&lang=js&"
export * from "./ReleaseManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ced0ac",
  null
  
)

export default component.exports